import * as z from "zod/v4";

export const deletePreset = {
  name: "deletePreset" as const,
  input: z.object({ _id: z.string() }),
  output: z.object({ success: z.boolean() }),
};
